const _excluded = ["size"];
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++)
      (o = n[r]),
        -1 === t.indexOf(o) &&
          {}.propertyIsEnumerable.call(e, o) &&
          (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
      if (-1 !== e.indexOf(n)) continue;
      t[n] = r[n];
    }
  return t;
}
function _extends() {
  return (
    (_extends = Object.assign
      ? Object.assign.bind()
      : function (n) {
          for (var e = 1; e < arguments.length; e++) {
            var t = arguments[e];
            for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
          }
          return n;
        }),
    _extends.apply(null, arguments)
  );
}
import React from "react";
var Linkedin24 = function Linkedin24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    _extends(
      {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
      props,
    ),
    /*#__PURE__*/ React.createElement("path", {
      d: "M19.04 19.04h-2.962V14.4c0-1.107-.02-2.531-1.542-2.531-1.543 0-1.78 1.206-1.78 2.45v4.722H9.794V9.497h2.845v1.304h.04a3.118 3.118 0 0 1 2.807-1.541c3.003 0 3.557 1.975 3.557 4.546l-.001 5.235zM6.45 8.194a1.72 1.72 0 1 1 0-3.44 1.72 1.72 0 0 1 0 3.44zM7.93 19.04H4.965V9.497H7.93v9.544zM20.518 2H3.476A1.46 1.46 0 0 0 2 3.443v17.113A1.46 1.46 0 0 0 3.476 22h17.042A1.463 1.463 0 0 0 22 20.556V3.442A1.463 1.463 0 0 0 20.518 2",
      fill: "currentColor",
    }),
  );
};
const sizeMap = {
  24: Linkedin24,
};
export function Linkedin(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    console.warn(
      new Error(
        "The '".concat(
          size,
          "' size is not supported by the 'Linkedin' icon. Please use one of the available sizes: '24'.",
        ),
      ),
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
